var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReservationList',{attrs:{"reservations":_vm.reservationList},on:{"edit-reservation":_vm.openEditReservation,"delete-reservation":_vm.deleteReservation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }